import { useState } from "react";
import { saveValuationMethod } from "../Api/ValuationMethod";
import { Accordion,
  AccordionItem,
  AccordionBody,Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo"; // Loader
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const ValuationMethod = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [valuationData, setValuationData] = useState({
    code: "",
    description: "",
  });

  const handleChange = (e) => {
    setValuationData({ ...valuationData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveValuationMethod(valuationData);
      toast.success("✅ Valuation Method Added Successfully");
      setValuationData({
        code: "",
        description: "",
      });
      navigate("/viewValuationMethod"); 
    } catch (error) {
      toast.error("❌ Failed to Add Valuation Method");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
      <div className="container gl-master-fields">
            <h2 className="fields-title">Valuation Method</h2>
            <Form onSubmit={handleSubmit} className="fields-form">
            <Accordion
            defaultActiveKey="0"
            className="gl-master-accordion"
          >
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={valuationData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={valuationData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
              <div className="fields-btn-container" style={{ marginTop: 16 }}>
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Valuation Method
                </Button>
              </div>
            </Form>
          
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ValuationMethod;
